<app-corporate-header></app-corporate-header>
<div class="container track-details">
  <div class="row ledger_row">
    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
      <div class="truck-left">
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/dashboard.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToDashboard()">Dashboard</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/trip.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToBookATrips()">Book a Trip</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/trp.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToTrips()">Trips</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/wo.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoTOWorkOrders()">Work Orders</h5>
          </div>
        </div>
        <div class="dashboard-menu active">
          <div class="truck-left-icon">
            <img src="assets/img/ledg.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToLedger()">Ledger</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/help.svg" alt="" />
          </div>
          <div class="truck-left-details" (click)="help()">
            <h5>Help</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12">
      <div [class.spinner]="ledgerLoading"></div>

      <form [formGroup]="ledgerForm">
        <div class="filter_container">
          <button class="download_btn" (click)="downloadXl(downloadArray)">
            <img src="assets/img/download.svg" alt="" />Download
          </button>
          <p>Payment Ledger</p>
          <button class="save_btn" *ngIf="searchOpen" (click)="searchBtn()">
            <img src="assets/img/search-white.svg" alt="" />
          </button>
          <div *ngIf="searchData" class="search_button">
            <input
              class="search pl-2"
              placeholder="search Trip Id"
              formControlName="trip_id"
              id="driverNumber"
              (click)="Search()"
              #newItem
            />
            <img
              class="search_icon"
              (click)="searchBtn()"
              src="/assets/img/search-white.svg"
            />
          </div>
        </div>
        <div *ngIf="searchData" class="ledger_form">
          <div class="row">
            <div class="col-md-2">
              <mat-form-field
                class="flex-gt-sm example-full-width truck-type-input"
              >
                <mat-datepicker-toggle matPrefix [for]="picker1">
                </mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <input
                  matInput
                  [matDatepicker]="picker1"
                  placeholder="From"
                  formControlName="from_date"
                  (click)="picker1.open()"
                />
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field
                class="flex-gt-sm example-full-width truck-type-input"
              >
                <mat-datepicker-toggle matPrefix [for]="picker2">
                </mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <input
                  matInput
                  [matDatepicker]="picker2"
                  placeholder="To"
                  formControlName="to_date"
                  (click)="picker2.open()"
                />
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field class="example-field">
                <mat-select
                  dropLocationSearchField
                  formControlName="from_loc"
                  placeholder="From Location"
                >
                  <mat-option
                    *ngFor="let fromloc of fromCityDetails"
                    value="{{ fromloc }}"
                    >{{ fromloc }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field class="example-field">
                <mat-select
                  placeholder="To Location"
                  dropLocationSearchField
                  formControlName="to_loc"
                >
                  <mat-option
                    *ngFor="let toloc of toCityDetails"
                    value="{{ toloc }}"
                    >{{ toloc }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field class="example-field">
                <mat-select placeholder="Trip ID" formControlName="trip_id">
                  <mat-option
                    *ngFor="let tripiD of tripDetails"
                    value="{{ tripiD }}"
                    >{{ tripiD }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field class="example-field">
                <mat-select placeholder="LR No" formControlName="lr_no">
                  <mat-option *ngFor="let lr of lrDetails" value="{{ lr }}">{{
                    lr
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <mat-form-field class="example-field">
                <mat-select
                  placeholder="Vehicle No"
                  formControlName="vehicle_no"
                >
                  <mat-option
                    *ngFor="let vechicleNumber of vehicleDetails"
                    value="{{ vechicleNumber }}"
                    >{{ vechicleNumber }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field class="example-field">
                <mat-select
                  placeholder="Sales Order Number"
                  formControlName="sales_order"
                >
                  <mat-option
                    *ngFor="let sales of salesorderDetails"
                    value="{{ sales }}"
                    >{{ sales }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field class="example-field">
                <mat-select
                  placeholder="Work Order Number"
                  formControlName="work_order"
                >
                  <mat-option
                    *ngFor="let workOrder of workOrderDetails"
                    value="{{ workOrder }}"
                    >{{ workOrder }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="filter_btn_grp">
              <button class="reset_btn" (click)="reset()">Reset</button>
              <button class="filter_btn" (click)="applyFilter()">Apply</button>
            </div>
          </div>
        </div>
        <section class="example-container mat-elevation-z8" tabindex="0">
          <table mat-table [dataSource]="ledgerList">
            <!-- Position Column -->
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td mat-cell *matCellDef="let element">
                {{ element.pickup_date | date : "dd-MM-yyyy" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="WONo">
              <th mat-header-cell *matHeaderCellDef>WO No</th>
              <td mat-cell *matCellDef="let element">
                {{ element.workorder_id }}
              </td>
            </ng-container>
            <ng-container matColumnDef="TripNo">
              <th mat-header-cell *matHeaderCellDef>Trip No</th>
              <td mat-cell *matCellDef="let element">
                {{ element.trip_id }}
              </td>
            </ng-container>
            <ng-container matColumnDef="LRNo">
              <th mat-header-cell *matHeaderCellDef>LR No</th>
              <td mat-cell *matCellDef="let element">
                {{ element.workOrderOtherDetails.lr_number }}
              </td>
            </ng-container>
            <ng-container matColumnDef="From">
              <th mat-header-cell *matHeaderCellDef>From</th>
              <td mat-cell *matCellDef="let element">
                {{ element.pickup_details.from_city_name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="To">
              <th mat-header-cell *matHeaderCellDef>To</th>
              <td mat-cell *matCellDef="let element">
                {{ element.dropoff_details.to_city_name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="TruckNo">
              <th mat-header-cell *matHeaderCellDef>Truck No</th>
              <td mat-cell *matCellDef="let element">
                {{ element.truck_id?.truck_number }}
              </td>
            </ng-container>
            <ng-container matColumnDef="DDCNo">
              <th mat-header-cell *matHeaderCellDef>DDC No</th>
              <td mat-cell *matCellDef="let element">
                {{ element.workOrderOtherDetails.ddc_no }}
              </td>
            </ng-container>
            <ng-container matColumnDef="LoadedQty">
              <th mat-header-cell *matHeaderCellDef>Loaded Qty</th>
              <td mat-cell *matCellDef="let element">
                {{ element.workOrderOtherDetails.loading_point }}
              </td>
            </ng-container>
            <ng-container matColumnDef="priceTon">
              <th mat-header-cell *matHeaderCellDef>Price/Ton</th>
              <td mat-cell *matCellDef="let element">
                ₹ {{ element.workOrderOtherDetails.price_per_ton }}
              </td>
            </ng-container>
            <ng-container matColumnDef="UnloadedQty">
              <th mat-header-cell *matHeaderCellDef>Unloaded Qty</th>
              <td mat-cell *matCellDef="let element">
                {{ element.workOrderOtherDetails.unloading_point }}
              </td>
            </ng-container>
            <ng-container matColumnDef="TotalNo">
              <th mat-header-cell *matHeaderCellDef>Total Amount</th>
              <td mat-cell *matCellDef="let element">
                ₹
                {{
                  element.workOrderOtherDetails.loading_point *
                    element.workOrderOtherDetails.price_per_ton ||
                    element.workOrderOtherDetails.unloading_point *
                      element.workOrderOtherDetails.price_per_ton
                }}
              </td>
            </ng-container>
            <ng-container matColumnDef="SalesOrderNo">
              <th mat-header-cell *matHeaderCellDef>Sales Order No</th>
              <td mat-cell *matCellDef="let element">
                {{ element.workOrderOtherDetails.sales_order_number }}
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </section>
      </form>
    </div>
  </div>
</div>
